import React, { useState, useEffect } from "react";
import { RadioGroup, Popover } from "@headlessui/react";

import Button from "../actions/Button";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/outline";
import * as Text from "@/components/text";
import { useRouter } from "next/router";

export const initiativesMap = [
  // {
  //   name: "Todas las iniciativas",
  //   slug: "todas-las-iniciativas",
  // },
  {
    name: "Gira de Documentales",
    slug: "gira-ambulante",
  },
  {
    name: "Ambulante Presenta",
    slug: "ambulante-presenta",
  },
  {
    name: "Ambulante Más Allá",
    slug: "ambulante-mas-alla",
  },
];

export default function RadioFilterList() {
  const router = useRouter();
  const query = router.query;

  const initialValue = query.iniciativa
    ? initiativesMap.filter((i) => i.slug === query.iniciativa)[0]
    : {};

  const [selectedInitiative, setSelectedInitiative] = useState(initialValue);

  useEffect(() => {
    if (
      selectedInitiative.slug &&
      query?.iniciativa != selectedInitiative.slug
    ) {
      router.push({
        pathname: "/catalogo",
        query: { iniciativa: selectedInitiative.slug },
      });
    }
  }, [selectedInitiative]);

  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <Popover.Button
            as={Button}
            color={open ? "white-on-black-no-hover" : "white-on-black"}
            label={selectedInitiative.name || "Todas las iniciativas"}
            trailingIcon={
              open ? (
                <ChevronUpIcon width={32} height={32} />
              ) : (
                <ChevronDownIcon width={32} height={32} />
              )
            }
            className={"w-[240px] px-4 text-[14px] font-bold"}
          />

          <Popover.Panel className="absolute z-10 w-full border border-black   bg-white shadow-xl">
            <RadioGroup
              value={selectedInitiative}
              className="w-full divide-y-2"
              onChange={setSelectedInitiative}
            >
              <div className="flex w-full items-center">
                <RadioGroup.Option
                  value={initiativesMap[0]}
                  className="flex w-full px-3 py-3 focus:ring-black"
                >
                  {({ checked, active }) => (
                    <div
                      className="flex w-full items-center"
                      onClick={() => {
                        setSelectedInitiative({});
                        router.push({
                          pathname: "/catalogo",
                        });
                      }}
                    >
                      <RadioGroup.Label
                        htmlFor={"todas-las-peliculas"}
                        className="block w-full text-sm font-medium leading-6 text-gray-900"
                      >
                        <Text.Label>Todas las iniciativas </Text.Label>
                      </RadioGroup.Label>
                      <div className="flex-grow"></div>
                      <input
                        id={"todas-las-peliculas"}
                        name="notification-method"
                        type="radio"
                        checked={
                          checked ||
                          Object.entries(selectedInitiative).length === 0
                        }
                        className="h-4 w-4  border-gray-300 text-black focus:ring-black"
                      />
                    </div>
                  )}
                </RadioGroup.Option>
              </div>

              <div className="bg-neutral-50 px-3">
                <Text.ButtonLabel
                  className="uppercase text-neutral-500"
                  size="02"
                >
                  Por iniciativas
                </Text.ButtonLabel>
              </div>
              {initiativesMap.map((initiative) => (
                <div key={initiative.slug} className="flex w-full items-center">
                  <RadioGroup.Option
                    value={initiative}
                    className="flex w-full px-3 py-3 focus:ring-black"
                  >
                    {({ checked, active }) => (
                      <div className="flex w-full items-center">
                        <RadioGroup.Label
                          htmlFor={initiative.slug}
                          className="block w-full text-sm font-medium leading-6 text-gray-900"
                        >
                          <Text.Label> {initiative.name}</Text.Label>
                        </RadioGroup.Label>
                        <div className="flex-grow"></div>
                        <input
                          id={initiative.slug}
                          name="notification-method"
                          type="radio"
                          checked={checked}
                          className="h-4 w-4  border-gray-300 text-black focus:ring-black"
                        />
                      </div>
                    )}
                  </RadioGroup.Option>
                </div>
              ))}
            </RadioGroup>
          </Popover.Panel>
        </>
      )}
    </Popover>
  );
}
